import {BonusActivePanelUntilContentStyled} from "./styled/BonusActivePanelUntilContentStyled.js";
import moment from "moment";
import { useLangContext } from "../../../../providers/LangProvider/LangProviderContext.js";

function BonusActivePanelUntilContent(props) {
    const {bonus, flat} = props;
    const {getLangPath} = useLangContext();

    return <BonusActivePanelUntilContentStyled flat={flat}>
        {getLangPath('bonus.gift50.till')}:
        <b className="ms-1">{moment(bonus.till).format('DD.MM, HH:mm')}</b>
    </BonusActivePanelUntilContentStyled>
}

export default BonusActivePanelUntilContent;
